const VARIABLE = 0;
const TWIN = 1;
const DOUBLE = 2;

const getLabels = () => ({
	[VARIABLE]: 'enums.BedConfig.labels.variable',
	[TWIN]: 'enums.BedConfig.labels.twin',
	[DOUBLE]: 'enums.BedConfig.labels.double',
});

const getOptionLabels = () => ({
	[VARIABLE]: 'enums.BedConfig.optionLabels.variable',
	[TWIN]: 'enums.BedConfig.optionLabels.twin',
	[DOUBLE]: 'enums.BedConfig.optionLabels.double',
});

const getOptions = () => {
	const options = [];

	for (let value of Object.keys(getOptionLabels())) {
		const label = getOptionLabels()[value];
		options.push({value, label});
	}

	return options;
};

const getLabel = (value) => {
	return getLabels()[value];
};

const getApiValue = (value) => {
	const apiValue = {
		[VARIABLE]: '',
		[TWIN]: 0,
		[DOUBLE]: 1,
	}[value];

	return apiValue || '';
};

export default {
	VARIABLE,
	TWIN,
	DOUBLE,

	getOptions,
	getLabels,
	getLabel,
	getApiValue,
};


// WEBPACK FOOTER //
// ./src/enums/BedConfig.js